import TransitionLayout from '@/ui/TransitionLayout'
import EmptyState from '@/ui/EmptyState'
import animation from '@/ui/lotties/Nomad.json'

const CantAccessKnowledgeBase = () => {
  return (
    <TransitionLayout>
      <div className="mobile-layout">
        <EmptyState animation={animation} title="No has activado esta sección">
          <p className="empty-text">No tienes acceso a esta sección.</p>
        </EmptyState>
      </div>
    </TransitionLayout>
  )
}

export default CantAccessKnowledgeBase
